/*
 * One-tap post starter prompts for the feed composer. Prefills are Norwegian on
 * purpose (post CONTENT for a Norwegian club audience); the chip LABELS are
 * i18n'd via textKey with the English defaultText inside the <Text> tag.
 * Module-level constants — never mutate.
 */
import { GRADIENT_PICKER_LIST } from './fieldsHelpers';

const gradientByName = (name) => {
    const entry = GRADIENT_PICKER_LIST.find(([, entryName]) => entryName === name);
    return entry ? entry[0] : '';
};

export const POST_PROMPTS = [
    { id: 'training', textKey: 'prompt-training', defaultText: '🎯 Today\'s training', prefill: '🎯 Dagens treningsøkt: ', background: gradientByName('Spotlight') },
    { id: 'matchreport', textKey: 'prompt-matchreport', defaultText: '🏆 Match report', prefill: '🏆 Stevnerapport: ', background: gradientByName('Gull') },
    { id: 'photo', textKey: 'prompt-photo', defaultText: '📸 Shot of the week', prefill: '📸 Ukens blinkskudd! ', background: '' },
    { id: 'question', textKey: 'prompt-question', defaultText: '💬 Ask the club', prefill: '💬 ', background: gradientByName('NorthSea') },
    { id: 'newmember', textKey: 'prompt-newmember', defaultText: '👋 New here?', prefill: '👋 Hei! Jeg heter ', background: gradientByName('Midnattssol') },
];

// A prompt may only replace the ingress when the user hasn't typed anything of
// their own: empty/whitespace, or text exactly matching some prompt's prefill
// (i.e. the user is switching between prompts).
export function canApplyPrompt(currentIngress) {
    const text = (currentIngress || '').trim();
    if (text === '') {
        return true;
    }
    return POST_PROMPTS.some(p => p.prefill.trim() === text);
}
